import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiMail, FiPhone, FiMapPin,
  FiInstagram, FiLinkedin, FiTwitter, FiFacebook,
  FiHome, FiUsers, FiBriefcase, FiSend, FiFileText,
  FiActivity, FiSmartphone, FiShoppingCart, FiTrendingUp,
  FiGrid, FiMonitor, FiAward, FiBookOpen
} from 'react-icons/fi';
import { IoRestaurantOutline } from 'react-icons/io5';
import { MdFitnessCenter } from 'react-icons/md';
import { TbRobot } from 'react-icons/tb';

const quickLinks = [
  { label: 'Home', to: '/', icon: <FiHome className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'About Us', to: '/about', icon: <FiUsers className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Portfolio', to: '/portfolio', icon: <FiBriefcase className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Contact', to: '/contact', icon: <FiSend className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Blogs', to: '/blog', icon: <FiFileText className="text-[#F3CA52] w-3.5 h-3.5" /> },
];

const services = [
  { label: 'Web & Mobile Apps', to: '/services/web-mobile-apps', icon: <FiSmartphone className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'CMS / Ecommerce', to: '/services/cms-ecommerce', icon: <FiShoppingCart className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Digital Marketing & Strategy', to: '/services/digital-marketing', icon: <FiTrendingUp className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Graphic & Video Design', to: '/services/graphic-design', icon: <FiGrid className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'UI/UX Consulting Design', to: '/services/ui-ux-design', icon: <FiMonitor className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'AI-Powered Technologies', to: '/services/ai-technologies', icon: <TbRobot className="text-[#F3CA52] w-3.5 h-3.5" /> },
];

const industries = [
  { label: 'Healthcare Portal', to: '/industries/healthcare', icon: <FiActivity className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Fitness & Gym', to: '/industries/fitness', icon: <MdFitnessCenter className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Home Services', to: '/industries/home-services', icon: <FiHome className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Real Estate Maps', to: '/industries/real-estate', icon: <FiHome className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Ecommerce Retail', to: '/industries/ecommerce', icon: <FiShoppingCart className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Restaurant & POS', to: '/industries/restaurant', icon: <IoRestaurantOutline className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Coaching Mentor', to: '/industries/coaching', icon: <FiUsers className="text-[#F3CA52] w-3.5 h-3.5" /> },
  { label: 'Education LMS', to: '/industries/education', icon: <FiBookOpen className="text-[#F3CA52] w-3.5 h-3.5" /> },
];

const policies = [
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Refund Policy', to: '/refund' },
  { label: 'Terms of Use', to: '/term' },
];

const socials = [
  { icon: FiInstagram, href: 'https://instagram.com/rojrztech', label: 'Instagram' },
  { icon: FiLinkedin, href: 'https://linkedin.com/company/rojrztech', label: 'LinkedIn' },
  { icon: FiTwitter, href: 'https://twitter.com/rojrztech', label: 'Twitter' },
  { icon: FiFacebook, href: 'https://facebook.com/rojrztech', label: 'Facebook' },
];

const Footer = () => {
  return (
    <footer className="w-full bg-transparent text-white relative z-10 pt-16 pb-10 select-none">

      {/* ═══════════════════════════════════════════════════════════
          UPPER FOOTER CARD
      ═══════════════════════════════════════════════════════════ */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <div className="w-full rounded-[2rem] sm:rounded-[3rem] bg-zinc-950/60 backdrop-blur-md border border-[#F3CA52]/10 px-8 sm:px-12 py-12 shadow-[0_20px_50px_rgba(0,0,0,0.8),0_0_50px_rgba(243,202,82,0.06)]">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 items-start">

            {/* Col 1: Brand (3 cols) */}
            <div className="lg:col-span-3 space-y-6">
              <div className="flex items-center gap-2">
                <img
                  src="/logo.png"
                  alt="RojrzTech Logo"
                  className="h-10 w-auto object-contain"
                  style={{
                    filter: 'invert(1) hue-rotate(180deg) brightness(2)',
                    mixBlendMode: 'screen',
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <span className="hidden text-2xl font-black tracking-tighter text-white font-sans">
                  Rojrz<span className="text-[#F3CA52]">Tech</span>
                </span>
              </div>
              <p className="text-xs sm:text-[13px] font-medium text-white leading-relaxed">
                At RojrzTech, we specialize in crafting innovative web and mobile solutions that drive your business forward. Expert team delivering custom designs tailored to your unique needs, ensuring exceptional user experiences and high performance.
              </p>

              {/* Socials */}
              <div className="flex items-center gap-3">
                {socials.map(({ icon: Icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-9 h-9 rounded-full bg-zinc-850 border border-[#F3CA52]/30 flex items-center justify-center text-white hover:text-[#F3CA52] hover:border-[#F3CA52]/50 hover:bg-[#F3CA52]/10 transition-all duration-300"
                  >
                    <Icon size={15} />
                  </a>
                ))}
              </div>
            </div>

            {/* Col 2: Quick Links (2 cols) */}
            <div className="lg:col-span-2 space-y-4">
              <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-2 border-l-2 border-[#F3CA52] pl-3">
                Quick Links
              </h4>
              <ul className="space-y-2.5 text-xs sm:text-[13px] font-semibold">
                {quickLinks.map(({ label, to, icon }) => (
                  <li key={label} className="whitespace-nowrap">
                    <Link
                      to={to}
                      className="hover:text-[#F3CA52] text-white transition-colors duration-300 flex items-center gap-2 group"
                    >
                      {icon}
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 3: Services (3 cols) */}
            <div className="lg:col-span-3 space-y-4">
              <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-2 border-l-2 border-[#F3CA52] pl-3">
                Our Services
              </h4>
              <ul className="space-y-2.5 text-xs sm:text-[13px] font-semibold">
                {services.map(({ label, to, icon }) => (
                  <li key={label} className="whitespace-nowrap">
                    <Link
                      to={to}
                      className="hover:text-[#F3CA52] text-white transition-colors duration-300 flex items-center gap-2 group"
                    >
                      {icon}
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 4: Industries (2 cols) */}
            <div className="lg:col-span-2 space-y-4">
              <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-2 border-l-2 border-[#F3CA52] pl-3">
                Our Industries
              </h4>
              <ul className="space-y-2.5 text-xs sm:text-[13px] font-semibold">
                {industries.map(({ label, to, icon }) => (
                  <li key={label} className="whitespace-nowrap">
                    <Link
                      to={to}
                      className="hover:text-[#F3CA52] text-white transition-colors duration-300 flex items-center gap-2 group"
                    >
                      {icon}
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 5: Contact (2 cols) */}
            <div className="lg:col-span-2 space-y-4">
              <h4 className="text-xs font-black text-white uppercase tracking-[0.2em] mb-2 border-l-2 border-[#F3CA52] pl-3">
                Contact Info
              </h4>
              <ul className="space-y-4 text-xs sm:text-sm font-semibold">
                <li>
                  <a href="mailto:info@rojrztech.com" className="flex items-start gap-2 text-[#F3CA52] hover:underline">
                    <FiMail size={14} className="mt-0.5 flex-shrink-0" />
                    info@rojrztech.com
                  </a>
                </li>
                <li>
                  <a href="tel:+15122544193" className="flex items-center gap-2 text-white hover:text-[#F3CA52] transition-colors">
                    <FiPhone size={14} className="flex-shrink-0 text-[#F3CA52]" />
                    +1 (512) 254-4193
                  </a>
                </li>
                <li className="flex items-start gap-2 text-white leading-snug font-semibold">
                  <FiMapPin size={14} className="mt-0.5 flex-shrink-0 text-[#F3CA52]" />
                  5900, Balcones Drive, STE 100, Austin, Texas, 78731
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════════
          BOTTOM COPYRIGHT BAR
      ═══════════════════════════════════════════════════════════ */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full rounded-xl sm:rounded-full bg-zinc-950/40 backdrop-blur-md border border-[#F3CA52]/10 px-6 sm:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">

          <p className="text-xs font-semibold tracking-wide text-white text-center sm:text-left order-2 sm:order-1">
            Copyright © 2024–26 <span className="text-white font-bold">RojrzTech</span>. All Rights Reserved.
          </p>

          <div className="flex items-center gap-6 text-xs font-bold uppercase tracking-wider order-1 sm:order-2">
            {policies.map(({ label, to }) => (
              <Link
                key={label}
                to={to}
                className="text-white hover:text-[#F3CA52] transition-colors duration-300"
              >
                {label}
              </Link>
            ))}
          </div>

        </div>
      </div>

    </footer>
  );
};

export default Footer;